// import React from 'react';

// const Experience = () => {
// 	return <div>Experience</div>;
// };

// export default Experience;
import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import styled from 'styled-components';
import aiLogo from '../../assets/ailogo.svg';
import { Heading } from '../../styles';
import { AppWrap, MotionWrap } from '../../wrapper';
const experiences = [
	{
		title: 'Front-End Developer',
		company_name: 'Arthashastra Intelligence',
		icon: aiLogo,
		iconBg: '#383E56',
		date: 'August 2020 - Present',
		points: [
			'Optimized build process, achieving an 86.9% reduction in build time from 8 minutes 15 seconds to 1 minute 5 seconds, resulting in increased efficiency and productivity.',
			'Collaborated with design, product, and backend teams to develop and implement high-quality responsive web applications using React JS and React TS, Styled-Components, Zustand, CSS, and Tailwind CSS.',
			'Developed and published 4 NPM packages, resulting in reducing development time by 70% across 7 different internal projects.',
			'Improved website performance by optimizing page load times through lazy loading, code splitting, and asset compression, resulting in a 45% reduction in overall load time and increased user engagement.',
			'Mentored and trained frontend interns, providing guidance on best practices, code reviews, and troubleshooting techniques, which significantly enhanced their skills and contributed to the growth of the team.',
		],
	},
];

const ExperienceCardImageDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
`;
const ExperienceCardImage = styled.img`
	width: 80%;
	height: 80%;
	object-fit: contain;
	border-radius: 50%;
`;
const ExperienceCardUl = styled.ul`
	padding: 16px 0 0 16px;
`;
const ParagraphText = styled.li`
	font-size: 0.9rem;
	text-align: left;
	color: var(--gray-color);
	line-height: 1.5;
	font-weight: 500;
	@media screen and (min-width: 2000px) {
		font-size: 1.1rem;
	}
`;
const whiteColor = '#ffffff';
const blackColor = '#030303';
const ExperienceCard = ({ experience }) => {
	return (
		<VerticalTimelineElement
			contentStyle={{
				background: whiteColor,
				color: blackColor,
			}}
			contentArrowStyle={{ borderRight: `7px solid ${blackColor}` }}
			date={experience.date}
			iconStyle={{ background: experience.iconBg }}
			icon={
				<ExperienceCardImageDiv>
					<ExperienceCardImage src={experience.icon} alt={experience.company_name} />
				</ExperienceCardImageDiv>
			}
			position='right'
		>
			<>
				<h3 className='text-white text-[24px] font-bold'>{experience.title}</h3>
				<p className='text-secondary text-[16px] font-semibold' style={{ margin: 0 }}>
					{experience.company_name}
				</p>
			</>

			<ExperienceCardUl className='mt-5 list-disc ml-5 space-y-2'>
				{experience.points.map((point, index) => (
					<ParagraphText
						key={`experience-point-${index}`}
						className='text-white-100 text-[14px] pl-1 tracking-wider'
					>
						{point}
					</ParagraphText>
				))}
			</ExperienceCardUl>
		</VerticalTimelineElement>
	);
};
const Experience = () => {
	return (
		<>
			<Heading>
				My <span>Work </span>Experience
			</Heading>
			<div
				style={{
					marginTop: '4rem',
				}}
			>
				<VerticalTimeline layout='1-column' lineColor='#1d1836'>
					{experiences.map((experience, index) => (
						<ExperienceCard key={`experience-${index}`} experience={experience} />
					))}
				</VerticalTimeline>
			</div>
		</>
	);
};

export default AppWrap(MotionWrap(Experience), 'Experience', 'app__primarybg');
// export default AppWrap(MotionWrap(Experience), 'Experience', 'app__whitebg');
